import React, {Fragment} from 'react';
import FETCH from '../Fetch';
import {Link} from 'react-router-dom';
import RegisterCoursesLoader from '../loaderComponents/RegisterCoursesLoader';
import CircularLoader from '../loaderComponents/CircularLoader';
import {toast} from './Notifier';
import {groupCoursesToSems} from '../utils';
import CourseRegistrationSuccessful from './CourseRegistrationSuccessful';
import RegisterCoursesUnitDetailsLoader from '../loaderComponents/RegisterCoursesUnitDetailsLoader';

class RegisterCourses extends React.Component {
  state = {
    loading: false,
    loadingUnitDetails: true,
    registeringCourses: false,
    coursesRegistered: false,
    noCoursesToRegister: false,
    courses: null,
    semester: 'first',
    coursesSelected: {
      first: [],
      second: [],
    },
    totalUnits: {
      first: 0,
      second: 0,
    },
    allCoursesSelected: {
      first: false,
      second: false,
    },
    previousCoursesSelected: {
      first: [],
      second: [],
    },
    extraCourses: {
      first: [],
      second: [],
    },
    extraCoursesData: {
      first: [],
      second: [],
      status: {
        first: 'loading',
        second: 'loading',
      },
    },
  };

  componentDidMount() {
    let {extraCoursesData} = this.state;
    FETCH.GetCourses()
      .then(async response => {
        if (response.status === 'success') {
          if (response.data.length === 0)
            return this.setState({
              noCoursesToRegister: true,
              noCoursesMessage: 'No courses to register',
            });
          await this.setState({
            courses: groupCoursesToSems(response.data),
          });
          await this.setState({totalUnits: this.setCoursesFromStart()});

          //   get first semester courses
          FETCH.getFirstSemesterExtraCourses()
            .then(async ({data}) => {
              let {
                extraCoursesData: {status},
              } = this.state;
              data = this.filterDuplicates(data, 'first');
              extraCoursesData['first'] = data;
              status['first'] = 'loaded';
              await this.setState({extraCoursesData});
            })
            .catch(err => {
              toast({message: err.message, status: 'error'});
            });

          //   get second semester courses
          FETCH.getSecondSemesterExtraCourses()
            .then(async ({data}) => {
              let {
                extraCoursesData: {status},
              } = this.state;
              data = this.filterDuplicates(data, 'second');
              extraCoursesData['second'] = data;
              status['second'] = 'loaded';
              await this.setState({extraCoursesData});
            })
            .catch(err => {
              toast({message: err.message, status: 'error'});
            });

          FETCH.getCourseConfig()
            .then(response => {
              if (response.status === 'success') {
                this.setState({
                  course_config: response.data,
                  extra_config: response.extra_config,
                  loadingUnitDetails: false,
                });
                if (
                  response.extra_config &&
                  response.extra_config.force_course_reg_image_upload == 1
                ) {
                  toast(
                    'You cannot register your courses until you upload your profile image',
                    {status: 'error'}
                  );
                }
              } else if (response.status === 'error') {
                this.setState({
                  course_config: [],
                  extra_config: {},
                  loadingUnitDetails: false,
                });
              }
            })
            .catch(err => {
              toast({message: err.message, status: 'error'});
            });
        } else {
          if (response && response.message) {
            toast(response.message, {status: 'error'});
            this.setState({error: true, errorMessage: response.message});
            return;
          }
          this.setState({
            error: true,
            errorMessage: 'Server Could Not Be Reached',
          });
        }
      })
      .catch(err => {
        toast({message: err.message, status: 'error'});
      });
  }

  filterDuplicates = (data, semster) => {
    let {courses} = this.state;
    return data.filter(course =>
      courses[semster].every(
        semCourse => semCourse.course_id !== course.course_id
      )
    );
  };

  setCourses = (evt, unit, id) => {
    let {semester, coursesSelected, previousCoursesSelected} = this.state;

    let semCourses = coursesSelected[semester];
    if (evt.target.checked) {
      semCourses.push({course_id: id, unit: unit});
    } else {
      let indexOfCourse = semCourses.indexOf(
        semCourses.find(semcourse => semcourse.course_id === id)
      );
      semCourses = semCourses.filter(course => course.course_id !== id);
    }
    coursesSelected[semester] = semCourses;

    this.setState({coursesSelected});
  };

  setCoursesFromStart = () => {
    let {courses, coursesSelected} = this.state;
    for (let key in courses) {
      courses[key].forEach((course, index, array) => {
        if (course.pre_select && !course.is_registered) {
          coursesSelected[key].push({
            course_id: course.course_id,
            unit: course.unit,
          });
        }
      });
    }

    this.setState({coursesSelected});
  };

  selectAllCourses = async checked => {
    let {
      courses,
      coursesSelected,
      semester,
      previousCoursesSelected,
    } = this.state;

    if (checked) {
      previousCoursesSelected[semester] = coursesSelected[semester].splice('');
      coursesSelected[semester] = courses[semester];

      this.setState({coursesSelected, previousCoursesSelected});
    } else {
      await this.setState({coursesSelected: previousCoursesSelected});
      this.setState({previousCoursesSelected: {first: [], second: []}});
    }
  };

  isAllCoursesSelected = async () => {
    let {courses, coursesSelected, semester, allCoursesSelected} = this.state;
    allCoursesSelected[semester] = true;
    let semCourses = courses[semester].map(course => course.course_id);
    let presentCourses =
      coursesSelected[semester].length > 0
        ? courses[semester].map(course => course.course_id)
        : 0;
    if (!presentCourses || presentCourses.length < semCourses.length) {
      allCoursesSelected[semester] = false;
      await this.setState({allCoursesSelected});
      return;
    }
    semCourses.forEach(course_id => {
      allCoursesSelected[semester] =
        allCoursesSelected && presentCourses.includes(course_id);
    });
    this.setState({allCoursesSelected});
    return;
  };

  getTotalUnits = () => {
    let {coursesSelected, semester, extraCourses} = this.state;
    let totalUnit =
      coursesSelected[semester].reduce((totalScore, course) => {
        return course.unit + totalScore;
      }, 0) +
      extraCourses[semester].reduce((totalScore, course) => {
        return course.unit + totalScore;
      }, 0);
    return totalUnit;
  };

  addExtraCourses = courses => {
    let {extraCourses, semester} = this.state;
    extraCourses[semester] = courses;

    this.setState({
      extraCourses,
    });
  };

  removeExtraCourse = id => {
    let {extraCourses, semester} = this.state;
    let semExtraCourse = extraCourses[semester];
    let indexOfCourse = semExtraCourse.indexOf(
      semExtraCourse.find(semcourse => semcourse.course_id === id)
    );
    semExtraCourse.splice(indexOfCourse, 1);
    extraCourses[semester] = semExtraCourse;
    this.setState({semExtraCourse});
  };

  coursesCanBeRegistered() {
    const {course_config, extra_config} = this.state;

    // check if global course registration is disabled
    if (extra_config.global_course_reg_status == 1) {
      toast(
        'You cannot register your courses at the moment, course registration is disabled',
        {
          status: 'error',
        }
      );
      return false;
    }

    // check if course registration is disabled due to image upload
    if (extra_config.force_course_reg_image_upload == 1) {
      toast(
        'You cannot register your courses until you upload your profile image',
        {
          status: 'error',
        }
      );
      return false;
    }

    
    // if there's no course config, a user can register any number of courses
    if(course_config.length === 0) return true;
    

    // check if total units of each semester does not exceed max_unit and not below min_unit
    const firstSemesterTotal =
      this.state.coursesSelected.first.reduce(
        (total, course) => total + course.unit,
        0
      ) +
      this.state.extraCourses.first.reduce(
        (total, course) => total + course.unit,
        0
      );

    const secondSemesterTotal =
      this.state.coursesSelected.second.reduce(
        (total, course) => total + course.unit,
        0
      ) +
      this.state.extraCourses.second.reduce(
        (total, course) => total + course.unit,
        0
      );

    const firstConfig =
      course_config &&
      course_config.filter(
        setting => setting.semester_readable.toLowerCase() == 'first'
      )[0];

    const secondConfig =
      course_config &&
      course_config.filter(
        setting => setting.semester_readable.toLowerCase() == 'second'
      )[0];

    if (firstSemesterTotal > firstConfig.max_unit) {
      toast(
        'Your first semester courses has exceeded the maximum units required',
        {
          status: 'error',
        }
      );
      return false;
    } else if (firstSemesterTotal < firstConfig.min_unit) {
      toast(
        'Your first semester courses is lower than the minimum units required',
        {
          status: 'error',
        }
      );
      return false;
    } else if (secondSemesterTotal > secondConfig.max_unit) {
      toast(
        'Your second semester courses has exceeded the maximum units required',
        {
          status: 'error',
        }
      );
      return false;
    } else if (secondSemesterTotal < secondConfig.min_unit) {
      toast(
        'Your second semester courses is lower than the minimum units required',
        {
          status: 'error',
        }
      );
      return false;
    } else {
      return true;
    }
  }

  registerCourses = () => {
    const courses = {
      course_ids: [
        ...this.state.coursesSelected.first.concat(
          this.state.coursesSelected.second,
          this.state.extraCourses.first,
          this.state.extraCourses.second
        ),
      ].map(x => x.course_id),
    };
    if (courses.course_ids.length === 0) return;

    if (this.coursesCanBeRegistered()) {
      this.setState({registeringCourses: true});

      FETCH.RegisterCourses(courses)
        .then(response => {
          if (response.status === 'error') {
            toast(response.message, {status: 'error'});
            this.setState({registeringCourses: false});
          }
          this.setState({
            registeringCourses: false,
            coursesRegistered: response.status === 'success' ? true : false,
          });
        })
        .catch(error => toast('error', {status: 'error'}));
    }
  };

  render() {
    let {
      noCoursesToRegister,
      noCoursesMessage,
      courses,
      semester,
      extraCoursesData,
      coursesSelected,
      allCoursesSelected,
      registeringCourses,
      coursesRegistered,
      error,
      errorMessage,
      extraCourses,
      course_config,
      extra_config,
      loadingUnitDetails,
    } = this.state;

    const config =
      course_config &&
      course_config.filter(
        setting => setting.semester_readable.toLowerCase() == semester
      )[0];
    const semesterDetails = {total_units_registered: this.getTotalUnits()};

    if (noCoursesToRegister) return <NoCourses message={noCoursesMessage} />;

    return error ? (
      <NoCourses message={errorMessage} />
    ) : registeringCourses ? (
      <RegisteringCourses />
    ) : coursesRegistered ? (
      <CourseRegistrationSuccessful />
    ) : courses ? (
      <main className="main-content-area col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-10 col-xl-10">
        <h1>Register Courses</h1>
        {/* card for course max/min credit unit, total registerable, c/o & outstanding courses  */}
        {loadingUnitDetails ? (
          <RegisterCoursesUnitDetailsLoader />
        ) : (
          <UnitDetails details={config} semesterDetails={semesterDetails} />
        )}
        {/* end card for course max/min credit unit, total registerable, c/o & outstanding courses  */}
        {/* card for course registration  */}
        <div className="row no-gutters">
          <div className="col-lg-12">
            <div className="card min-h-1000">
              <div className="card-header">
                <div className="row no-gutters">
                  <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    My Courses
                    <span className="bar-separator">
                      <select
                        onChange={e => {
                          this.setState({semester: e.target.value});
                        }}
                        className="short"
                      >
                        <option value="first">1st Semester</option>
                        <option value="second">2nd Semester</option>
                      </select>
                    </span>
                  </div>
                  <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 text-right">
                    <button
                      className="btn btn-solid "
                      data-toggle="modal"
                      data-backdrop="static"
                      data-keyboard="false"
                      // disable popup modal
                      data-target="#addCourses"
                    >
                      <i className="fas fa-plus mr-1" /> Add Course(s)
                    </button>
                  </div>
                </div>
              </div>
              <div className="card-body p-0 m-0">
                <AddCourses
                  addExtraCourses={this.addExtraCourses}
                  semester={semester}
                  availableCourses={extraCoursesData}
                />
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead>
                      <tr>
                        <th scope="col" width={80} className="pl-41">
                          <div className="custom-checkbox">
                            <input
                              type="checkbox"
                              defaultValue={1}
                              id="selectAll"
                              name="selectAll"
                              onChange={e => {
                                if (!courses[semester]) return;
                                this.selectAllCourses(e.target.checked);
                                allCoursesSelected[semester] = e.target.checked;
                                this.setState({allCoursesSelected});
                              }}
                            />
                            <label htmlFor="selectAll" />
                          </div>
                        </th>
                        <th scope="col" width={100}>
                          Code
                        </th>
                        <th scope="col" width={420}>
                          Course Title
                        </th>
                        <th scope="col" width={100}>
                          Unit
                        </th>
                        <th scope="col" width={80}>
                          Status
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {extraCourses[semester].length
                        ? extraCourses[semester].map(course => (
                            <AddedCourse
                              unit={course.unit}
                              status={course.status}
                              code={course.code}
                              title={course.title}
                              id={course.course_id}
                              checked={
                                extraCourses[semester].find(
                                  extcourse =>
                                    extcourse.course_id === course.course_id
                                )
                                  ? 1
                                  : 0
                              }
                              removeExtraCourse={this.removeExtraCourse}
                            />
                          ))
                        : null}

                      {courses[semester] &&
                        courses[semester].map(course => (
                          <Course
                            details={course}
                            isRegistered={course.is_registered}
                            key={course.course_id}
                            isAllCoursesSelected={this.isAllCoursesSelected}
                            checked={() => {
                              const checked = !!coursesSelected[semester].find(
                                pcourse =>
                                  pcourse.course_id === course.course_id
                              );
                              return checked;
                            }}
                            setCourses={this.setCourses}
                          />
                        ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <div className="card-footer bg-transparent">
                <div className="row no-gutters">
                  <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                    {/* remove active class to disable */}
                    <div className="courses-selected disable">
                      {coursesSelected[semester].length +
                        extraCourses[semester].length}{' '}
                      Courses selected
                    </div>
                  </div>
                  <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 text-right">
                    {/* remove active class to disable */}
                    <span className="units-selected disable">
                      {this.getTotalUnits()} Units{' '}
                    </span>
                    {/* subtitute active class for disabled to either make button active or inactive */}
                    <button
                      className={` btn btn-solid btn-primary-big btn-border-radius-course active ${
                        extra_config &&
                        extra_config.global_course_reg_status == 1
                          ? 'disabled'
                          : ''
                      }`}
                      disabled={
                        extra_config &&
                        extra_config.global_course_reg_status == 1
                      }
                      onClick={this.registerCourses}
                    >
                      Register Courses
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* card for outstanding fees */}
          </div>
        </div>

        {/* end card for news display   */}
      </main>
    ) : (
      <RegisterCoursesLoader input={true} />
    );
  }
}

const RegisteringCourses = () => (
  <main className="main-content-area col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-10 col-xl-10">
    <h1>Register Courses</h1>
    {/* card for course registration  */}
    <div className="row no-gutters">
      <div className="col-lg-12">
        <div className="card min-h-700 text-center justify-content-center align-items-centerr">
          <div className="registering-courses p-0 m-0">
            <h2>Registering your courses...</h2>
            <p className="small">This should only take few seconds</p>
            <CircularLoader />
          </div>
        </div>
        {/* card for outstanding fees */}
      </div>
    </div>
    {/* end card for news display   */}
  </main>
);

class Course extends React.Component {
  state = {};
  render() {
    let {
      details,
      setCourses,
      checked,
      isAllCoursesSelected,
      isRegistered,
    } = this.props;
    checked = checked() ? 1 : 0;
    return (
      <tr className={isRegistered ? 'opaque' : ''}>
        <th scope="row">
          <div className="custom-checkbox">
            <input
              onChange={
                isRegistered
                  ? null
                  : async e => {
                      setCourses(e, details.unit, details.course_id);
                      isAllCoursesSelected();
                    }
              }
              type="checkbox"
              checked={checked}
              defaultValue={1}
              id={details.course_id}
              name={details.course_id}
              disabled={isRegistered ? true : false}
            />
            <label htmlFor={details.course_id} />
          </div>
        </th>
        <td>{details.code}</td>
        <td>{details.title}</td>
        <td>{details.unit}</td>
        <td>{details.status}</td>
      </tr>
    );
  }
}

class AddCourses extends React.Component {
  state = {
    searchString: '',
    noCourseToAdd: {
      first: false,
      second: false,
    },
    selectedCourses: {
      first: [],
      second: [],
    },
  };
  getTotalUnits = () => {
    let {selectedCourses} = this.state;
    let {semester} = this.props;
    let totalUnit = selectedCourses[semester].reduce((totalScore, course) => {
      return course.unit + totalScore;
    }, 0);
    return totalUnit;
  };
  addCourses = () => {
    let {addExtraCourses, semester} = this.props;
    let {selectedCourses} = this.state;
    addExtraCourses(selectedCourses[semester]);
    window.$('#addCourses').modal('hide');
  };
  renderFilteredCourses = () => {
    let {searchString, selectedCourses} = this.state;
    let {semester, availableCourses} = this.props;
    let FilteredCourses = [];
    if (parseInt(searchString) < 10) {
      FilteredCourses = availableCourses[semester].filter(
        course => course.unit === parseInt(searchString)
      );
    } else {
      FilteredCourses = availableCourses[semester].filter(
        course =>
          course.code.toLowerCase().includes(searchString.toLowerCase()) ||
          course.title.toLowerCase().includes(searchString.toLowerCase())
      );
    }
    return FilteredCourses.length ? (
      FilteredCourses.map((course, i) => (
        <ExtraCourse
          title={course.title}
          unit={course.unit}
          code={course.code}
          checked={
            !!selectedCourses[semester].find(
              scourse => scourse.course_id === course.course_id
            )
              ? 1
              : 0
          }
          addOrRemoveCourse={this.addOrRemoveCourse}
          status={course.status}
          course={course}
          key={i}
        />
      ))
    ) : (
      <tr>
        <th scope="row">
          <div className="custom-checkbox" />
        </th>
        <td />
        <td>No Course Matchces Your Seacrh</td>
        <td />
        <td> </td>
      </tr>
    );
  };
  addOrRemoveCourse = (checked, course) => {
    let {selectedCourses} = this.state,
      {semester} = this.props,
      semSelectedCourses = selectedCourses[semester].splice(''),
      courseAlreadyselected = !!semSelectedCourses.find(
        semcourse => semcourse.course_id === course.course_id
      );
    if (checked) {
      if (courseAlreadyselected) return;
      semSelectedCourses.push(course);
    } else {
      let indexOfCourse = semSelectedCourses.indexOf(
        semSelectedCourses.find(
          semcourse => semcourse.course_id === course.course_id
        )
      );
      if (courseAlreadyselected) semSelectedCourses.splice(indexOfCourse, 1);
    }
    selectedCourses[semester] = semSelectedCourses;

    this.setState({selectedCourses});
    return;
  };

  render() {
    let {searchString, selectedCourses, noCourseToAdd} = this.state;
    let {
      semester,
      availableCourses,
      availableCourses: {status},
    } = this.props;
    let activeClass = () => {
      return !!selectedCourses[semester].length;
    };
    return (
      <Fragment>
        <div
          className="modal fade"
          id="addCourses"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog add-courses-modal" role="document">
            <div className="modal-content card ">
              <div className="modal-header card-header border-0">
                <h5 className="modal-title  m-auto" id="exampleModalLabel">
                  Add Courses
                </h5>
                <span className="fas fa-times" data-dismiss="modal" />
              </div>
              <div className="modal-body add-courses">
                <div className="input-group search-container w-100">
                  <input
                    type="text"
                    className="form-control m-auto search-bar"
                    id="search"
                    placeholder="🔍 Search Courses by unit, title or code"
                    onChange={e => {
                      this.setState({searchString: e.target.value});
                    }}
                  />
                </div>
                {availableCourses[semester].length === 0 ? (
                  <div className="card-body">
                    <div className="dashboard-transaction-container text-center">
                      <div className="empty-card text-center mt-3">
                        <button className="circle-bg-width-80 circle-bg circle-bg-gray">
                          <img
                            src={require('../assets/empty-fee.svg')}
                            className="svg"
                            alt="Min Unit"
                          />
                        </button>
                        <Fragment>
                          <p>
                            You do not have any course to select this semester
                          </p>
                        </Fragment>
                      </div>
                    </div>
                  </div>
                ) : (
                  <Fragment>
                    <div className="table-responsive">
                      <table className="table table-hover">
                        <thead>
                          <tr>
                            <th scope="col" width={80} className="pl-41" />
                            <th scope="col" width={100}>
                              Code
                            </th>
                            <th scope="col" width={420}>
                              Course Title
                            </th>
                            <th scope="col" width={100}>
                              Unit
                            </th>
                            <th scope="col" width={80}>
                              Status
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {status[semester] === 'loading' ? (
                            <tr>
                              <th scope="row" />
                              <td />
                              <td>Loading... please wait</td>
                              <td />
                              <td> </td>
                            </tr>
                          ) : searchString ? (
                            this.renderFilteredCourses()
                          ) : (
                            availableCourses[semester]
                              .sort((courseA, courseB) => {
                                if (
                                  !!selectedCourses[semester].find(
                                    course =>
                                      course.course_id === courseA.course_id
                                  ) &&
                                  !!selectedCourses[semester].find(
                                    course =>
                                      course.course_id === courseB.course_id
                                  )
                                ) {
                                  return 0;
                                } else if (
                                  !!selectedCourses[semester].find(
                                    course =>
                                      course.course_id === courseA.course_id
                                  )
                                ) {
                                  return -1;
                                } else if (
                                  !!selectedCourses[semester].find(
                                    course =>
                                      course.course_id === courseB.course_id
                                  )
                                ) {
                                  return 1;
                                }
                              })
                              .map((course, i) => (
                                <ExtraCourse
                                  title={course.title}
                                  unit={course.unit}
                                  code={course.code}
                                  id={course.course_id}
                                  isRegistered={course.is_registered}
                                  addOrRemoveCourse={this.addOrRemoveCourse}
                                  status={course.status}
                                  key={i}
                                  checked={
                                    !!selectedCourses[semester].find(
                                      scourse =>
                                        scourse.course_id === course.course_id
                                    )
                                      ? 1
                                      : 0
                                  }
                                  course={course}
                                />
                              ))
                          )}
                        </tbody>
                      </table>
                    </div>
                    <div className="card-footer bg-transparent">
                      <div className="row no-gutters">
                        <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                          {/* remove active class to disable */}
                          <div
                            className={`courses-selected ${
                              activeClass() ? 'active' : 'disable'
                            }`}
                          >
                            {selectedCourses[semester].length} Courses selected
                          </div>
                        </div>
                        <div className="col-xs-6 col-sm-6 col-md-6 col-lg-6 text-right">
                          {/* remove active class to disable */}
                          <span
                            className={`units-selected ${
                              activeClass() ? 'active' : 'disable'
                            }`}
                          >
                            {this.getTotalUnits()} Units
                          </span>
                          {/* subtitute active class for disabled to either make button active or inactive */}
                          <button
                            style={{
                              backgroundColor: activeClass() ? '#00d715' : '',
                            }}
                            onClick={this.addCourses}
                            className={`btn btn-primary-big btn-border-radius-course ${
                              activeClass() ? '' : 'disabled'
                            }`}
                          >
                            Select Courses
                          </button>
                        </div>
                      </div>
                    </div>
                  </Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

class ExtraCourse extends React.Component {
  render() {
    let {
      status,
      title,
      unit,
      code,
      addOrRemoveCourse,
      course,
      isRegistered,
      checked,
    } = this.props;
    return (
      <tr class={isRegistered ? 'opaque' : ''}>
        <th scope="row">
          <div className="custom-checkbox">
            <input
              type="checkbox"
              id={code}
              name={code}
              checked={checked}
              onChange={
                isRegistered
                  ? null
                  : e => {
                      addOrRemoveCourse(e.target.checked, course);
                    }
              }
              disabled={isRegistered ? true : false}
            />
            <label htmlFor={code} />
          </div>
        </th>
        <td>{code}</td>
        <td>{title}</td>
        <td>{unit}</td>
        <td>
          {' '}
          <span className={`status ${status}`}>{status}</span>
        </td>
      </tr>
    );
  }
}
class AddedCourse extends React.Component {
  render() {
    let {
      status,
      title,
      unit,
      code,
      id,
      removeExtraCourse,
      checked,
    } = this.props;
    return (
      <tr>
        <th scope="row">
          <div className="custom-checkbox">
            <input
              type="checkbox"
              id={code + '2'}
              name={code}
              checked={checked}
              onChange={e => {
                removeExtraCourse(id);
              }}
            />
            <label htmlFor={code + '2'} />
          </div>
        </th>
        <td>{code}</td>
        <td>{title}</td>
        <td>{unit}</td>
        <td>
          {' '}
          <span className={`status ${status}`}>{status}</span>
        </td>
      </tr>
    );
  }
}

const NoCourses = ({message}) => (
  <main className="main-content-area col col-12 col-xs-9 col-sm-8 col-md-9 col-lg-10 col-xl-10">
    <h1>Register Courses</h1>
    <div className="row no-gutters">
      <div className="col-lg-12 m-auto">
        <div className="card ">
          <div className="card-body">
            <div className="dashboard-transaction-container text-center">
              <div className="empty-card text-center mt-3">
                <button className="circle-bg-width-80 circle-bg circle-bg-gray">
                  <img
                    src={require('../assets/empty-fee.svg')}
                    className="svg"
                    alt="Min Unit"
                  />
                </button>

                <Fragment>
                  <p>{message}</p>
                  {/* <small>Your are not able to register courses right now, try again later</small> */}
                </Fragment>
              </div>
              <Fragment>
                <Link
                  className="btn btn-primary btn-primary-color  mt-5"
                  to="/"
                >
                  Dashboard
                </Link>
              </Fragment>
            </div>
          </div>
        </div>
        {/* card for outstanding fees */}
      </div>
    </div>

    {/* end card for news display   */}
  </main>
);

class UnitDetails extends React.Component {
  componentDidMount() {
    // course overview slider

    const $ = window.jQuery || window.$;
    $('.course-overview-slider').owlCarousel({
      items: 4,
      loop: false,
      margin: 20,
      dots: false,
      navText: [
        "<i class='fas fa-long-arrow-left'></i>",
        "<i class='fas fa-long-arrow-right'></i>",
      ],
      responsiveClass: true,
      responsive: {
        0: {
          items: 1,
          nav: true,
        },
        480: {
          items: 1,
          nav: true,
        },
        576: {
          items: 1,
          nav: true,
        },
        768: {
          items: 2,
          nav: true,
        },
        992: {
          items: 3,
          nav: true,
        },
        1200: {
          items: 4,
          nav: false,
          loop: false,
        },
      },
    });
  }
  render() {
    const {details = {}, semesterDetails} = this.props;

    return (
      <div className="row no-gutters">
        <div className="col-lg-12">
          <div className="card min-h-auto">
            <div className="card-body">
              <div
                className="course-overview-slider owl-carousel owl-theme"
                ref={el => (this.courseOverviewSlider = el)}
              >
                <div className="course-overview p-0 text-center">
                  <div className="course-border">
                    <div className="number m-0 fs-36-l">
                      {details.min_unit || 'n/a'}
                    </div>
                    <p>Minimum Units Required</p>
                  </div>
                </div>
                <div className="course-overview p-0 text-center">
                  <div className="course-border">
                    <div className="number m-0 fs-36-l">
                      {details.max_unit || 'n/a'}
                    </div>
                    <p>Maximum Units Required</p>
                  </div>
                </div>
                <div className="course-overview p-0 text-center">
                  <div className="course-border">
                    <div className="number m-0 fs-36-l">
                      {' '}
                      {semesterDetails.total_units_registered}{' '}
                    </div>
                    <p>Total Unit Registered</p>
                  </div>
                </div>
                <div className="course-overview p-0 text-center">
                  <div className="border-0 course-border">
                    <div className="number m-0 fs-36-l">n/a</div>
                    <p>CO/Outstanding Course(s)</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* card for outstanding fees */}
        </div>
      </div>
    );
  }
}
export default RegisterCourses;
